class NailFinderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupStartButton();
  }

  setupStartButton() {
    const quizBanner = this.querySelector('[data-quiz-banner]');
    const startButton = this.querySelector('[data-start-button]');
    const quizSection = this.querySelector('[data-quiz]');

    if (startButton && quizSection) {
      startButton.addEventListener('click', () => {
        quizSection.classList.add('fade-in');
        quizBanner.classList.add('is-hidden');
        quizSection.classList.remove('is-hidden')
      });
    }
  }
}

customElements.define('nail-finder', NailFinderComponent);

class TabsComponent extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.initTabs();
      this.setupRetakeQuiz();
  }

  initTabs() {
      const tabButtons = this.querySelectorAll('.tab-link:not([data-retake-quiz])');
      const tabPanels = Array.from(this.querySelectorAll('.tab-content'));
      const nextButtons = this.querySelectorAll('.c-content-tabs__next button:not([data-retake-quiz])');

      this.resetButtons(tabButtons, nextButtons);

      tabPanels.forEach((panel, index) => {
          const radios = panel.querySelectorAll('input[type="radio"]');
          radios.forEach(radio => {
              radio.addEventListener('change', () => {
                  nextButtons[index].disabled = false;
                  if (index + 1 < tabButtons.length) {
                      tabButtons[index + 1].disabled = false;
                  }
                  this.checkAllSelected(tabPanels, nextButtons, tabButtons);
              });
          });
      });

      tabButtons.forEach((tabButton) => {
          tabButton.addEventListener('click', (event) => {
              const targetId = event.target.dataset.target;

              tabPanels.forEach((tabPanel) => {
                  tabPanel.classList.toggle('is-active', tabPanel.id === targetId);
                  tabPanel.classList.toggle('is-hidden', tabPanel.id !== targetId);
              });

              tabButtons.forEach(button => {
                  button.classList.toggle('is-active', button.dataset.target === targetId);
              });
          });
      });

      tabButtons[0].click();
  }

  checkAllSelected(tabPanels, nextButtons, tabButtons) {
      let allSelected = true;
      tabPanels.forEach(panel => {
          if (!panel.querySelector('input[type="radio"]:checked')) {
              allSelected = false;
          }
      });

      if (allSelected && nextButtons.length > 0) {
          nextButtons[nextButtons.length - 1].disabled = false;
          tabButtons[tabButtons.length - 1].disabled = false; 
      }
  }

  setupRetakeQuiz() {
      const retakeButton = this.querySelector('[data-retake-quiz]');
      if (retakeButton) {
          retakeButton.addEventListener('click', () => {
              this.querySelectorAll('input[type="radio"]').forEach(radio => {
                  radio.checked = false;
              });
              this.resetButtons(this.querySelectorAll('.tab-link'), this.querySelectorAll('.c-content-tabs__next button'));
              this.initTabs();
          });
      }
  }

  resetButtons(tabButtons, nextButtons) {
      tabButtons.forEach((button, index) => {
          button.disabled = index !== 0;
      });

      nextButtons.forEach(button => {
          button.disabled = true;
      });

      const retakeButton = this.querySelector('[data-retake-quiz]');
      if (retakeButton) {
          retakeButton.disabled = false; 
      }
  }
}

customElements.define('tabs-component', TabsComponent);
